import { useMainStore } from '@/core/store/main.ts';
import { AppScreens } from '@/shared/types';
import { useIonRouter } from '@ionic/vue';
import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { logAnalyticsEvent } from '@/core/analytics/analytics';
import { AnalyticsEventName, SectionEntrySourceNames } from '@/core/analytics/types';

export const useNavigationBarStore = defineStore('NavigationBarStore', () => {
  const { activeScreen } = storeToRefs(useMainStore());

  const router = useIonRouter();

  const navList = computed(() => {
    return [
      {
        name: AppScreens.Home,
        icon: 'home-outline',
        animatedIcon: 'animated-icon-home',
        active: activeScreen.value === AppScreens.Home,
        visible: true,
        action: () => {
          router.push({
            name: AppScreens.Home,
          });
        },
      },
      {
        name: AppScreens.VideoBible,
        icon: 'play-outline',
        animatedIcon: 'animated-icon-video-bible',
        active: activeScreen.value === AppScreens.VideoBible ||
          activeScreen.value === AppScreens.ReadingPlans ||
          activeScreen.value === AppScreens.ReadingPlanDetail ||
          activeScreen.value === AppScreens.ReadingPlanDay,
        visible: true,
        action: () => {
          router.push({
            name: AppScreens.VideoBible,
          });

          logAnalyticsEvent({
            name: AnalyticsEventName.SectionEntry,
            params: {
              section_name: AppScreens.VideoBible,
              source: SectionEntrySourceNames.Navigation,
            },
          });
        },
      },
      {
        name: AppScreens.Stories,
        icon: 'interactive-outline',
        animatedIcon: 'animated-icon-interactive-bible',
        active: activeScreen.value === AppScreens.Stories || activeScreen.value === AppScreens.Story,
        visible: true,
        action: () => {
          const hasProgress = localStorage.getItem('interactive-experience:last-point');

          router.push({
            name: hasProgress ? AppScreens.Story : AppScreens.Stories,
          });

          logAnalyticsEvent({
            name: AnalyticsEventName.SectionEntry,
            params: {
              section_name: AppScreens.Stories,
              source: SectionEntrySourceNames.Navigation,
            },
          });
        },
      },
      // {
      //   name: AppScreens.InteractiveBible,
      //   icon: 'interactive-outline',
      //   animatedIcon: 'animated-icon-interactive-bible',
      //   active: activeScreen.value === AppScreens.InteractiveBible,
      //   visible: true,
      //   action: () => {
      //     router.push({
      //       name: AppScreens.InteractiveBible,
      //     });
      //   },

      // logAnalyticsEvent({
      //   name: AnalyticsEventName.SectionEntry,
      //   params: {
      //     section_name: AppScreens.Stories,
      //     source: SectionEntrySourceNames.Navigation,
      //   },
      // });
      // },
      {
        name: AppScreens.ReadingPlans,
        icon: 'mini-calendar-outline',
        animatedIcon: 'animated-icon-mini-calendar',
        active: activeScreen.value === AppScreens.ReadingPlans,
        visible: false,
        action: () => {
          router.push({
            name: AppScreens.ReadingPlans,
          });

          logAnalyticsEvent({
            name: AnalyticsEventName.SectionEntry,
            params: {
              section_name: AppScreens.ReadingPlans,
              source: SectionEntrySourceNames.Navigation,
            },
          });
        },
      },
      {
        name: AppScreens.Courses,
        icon: 'book-outline',
        animatedIcon: 'animated-icon-courses',
        active: activeScreen.value === AppScreens.Courses,
        visible: false,
        action: () => {
          router.push({
            name: AppScreens.Courses,
          });
        },
      },
      {
        name: AppScreens.PrayerExperience,
        icon: 'prayer-hands-outline',
        animatedIcon: 'animated-icon-prayer-experience',
        active: activeScreen.value === AppScreens.PrayerExperience,
        visible: true,
        action: () => {
          router.push({
            name: AppScreens.PrayerExperience,
          });

          logAnalyticsEvent({
            name: AnalyticsEventName.SectionEntry,
            params: {
              section_name: AppScreens.PrayerExperience,
              source: SectionEntrySourceNames.Navigation,
            },
          });
        },
      },
      {
        name: AppScreens.Menu,
        icon: 'burger',
        animatedIcon: 'animated-icon-burger',
        active: activeScreen.value === AppScreens.Menu,
        visible: true,
        action: () => {
          const { sideMenuVisible } = storeToRefs(useMainStore());

          sideMenuVisible.value = true;
        },
      },
    ];
  });

  return {
    navList,
  };
});
